
const ERRORS = {
    PAGE_TRANSITION: "PAGE_TRANSITION",
    PAGE_SUBMIT_ERRORS: "PAGE_SUBMIT_ERRORS"
};

export default ERRORS;